import React, { useState } from "react";
import { Link } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import logo from "../../assets/centrum_assets/design/index/LOGO.png";
import { Typography, Box } from "@mui/material";

const Footer = () => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  return (
    <footer className="footer">
      <div className="footer-wrapper">
        <div className="container mx-auto px-4">
          <div className="footer-row">
            {/* QUICK CONTACT */}
            <div className="footer-list">
              <h6 className="custom-font-weight text-[16px] mb-5 tracking-wide uppercase">
                Quick Contact
              </h6>
              <div className="space-y-3">
                <span className="text-gray-500 text-[14px] block leading-tight">
                  If you have any question or need <br /> help, feel free to contact our team.
                </span>
                <div className="flex items-center gap-2 text-gray-500 mt-5">
                  <PhoneIcon sx={{ color: "#7BB241", fontSize: 18, }} />
                  <span className="text-[14px]">+63 75-653-0008</span>
                </div>
                <div className="flex items-center gap-2 text-gray-500">
                  <LocationOnIcon sx={{ color: "#7BB241", fontSize: 18 }} />
                  <span className="text-[14px] leading-tight">
                    RRF Building - San Miguel, Calasiao, <br />Pangasinan
                  </span>
                </div>
                <a href="https://maps.app.goo.gl/TmgTZcLk3hhsPVmz5" target="_blank" rel="noopener noreferrer"className="inline-block pt-3 text-[#7BB241] font-semibold text-[14px] tracking-[3px] hover:text-[#00b5e2]">
                  GET DIRECTIONS → 
                </a>
              </div>
            </div>
            {/* QUICK LINKS */}
            <div className="footer-list">
              <h6 className="custom-font-weight text-[16px] mb-5 tracking-wide uppercase">
                Quick Links
              </h6>
              <ul className="space-y-4"> 
                <li>
                  <button onClick={() => toggleDropdown("about")} className="flex items-center gap-1 text-gray-500 hover:text-[#00b5e2] font-medium w-full text-left text-[14px]">
                    {openDropdown === "about" ? <KeyboardArrowDownIcon sx={{ fontSize: 16, color: '#00b5e2' }} /> : <KeyboardArrowRightIcon sx={{ fontSize: 16, color: '#00b5e2' }} />}
                    About Us
                  </button>
                  <ul className={`overflow-hidden transition-all duration-300 space-y-0 ${openDropdown === "about" ? "max-h-40" : "max-h-0"}`}>
                    <li><Link to="/about" className="block pl-7 text-gray-500 hover:text-[#00b5e2] text-[14px] leading-tight">About Centrum</Link></li>
                    <li><Link to="/milestone" className="block pl-7 text-gray-500 hover:text-[#00b5e2] text-[14px] leading-tight">Milestones</Link></li>
                    <li><Link to="/News" className="block pl-7 text-gray-500 hover:text-[#00b5e2] text-[14px] leading-tight">News</Link></li>
                  </ul>
                </li>
                <li>
                  <button onClick={() => toggleDropdown("stations")} className="flex items-center gap-1 text-gray-500 hover:text-[#00b5e2] font-medium w-full text-left text-[14px]">
                    {openDropdown === "stations" ? <KeyboardArrowDownIcon sx={{ fontSize: 16, color: '#00b5e2' }} /> : <KeyboardArrowRightIcon sx={{ fontSize: 16, color: '#00b5e2' }} />}
                    Stations
                  </button>
                  <ul className={`overflow-hidden transition-all duration-300 space-y-0 ${openDropdown === "stations" ? "max-h-32" : "max-h-0"}`}>
                    <li><Link to="/stations" className="block pl-7 text-gray-500 hover:text-[#00b5e2] text-[14px] leading-tight">Opened Stations</Link></li>
                    <li><Link to="/finder" className="block pl-7 text-gray-500 hover:text-[#00b5e2] text-[14px] leading-tight">Station Finder</Link></li>
                  </ul>
                </li>
                <li>
                  <button onClick={() => toggleDropdown("news")} className="flex items-center gap-1 text-gray-500 hover:text-[#00b5e2] font-medium w-full text-left text-[14px]">
                    {openDropdown === "news" ? <KeyboardArrowDownIcon sx={{ fontSize: 16, color: '#00b5e2' }} /> : <KeyboardArrowRightIcon sx={{ fontSize: 16, color: '#00b5e2' }} />}
                    News & Media
                  </button>
                  <ul className={`overflow-hidden transition-all duration-300 space-y-0 ${openDropdown === "news" ? "max-h-40" : "max-h-0"}`}>
                    <li><Link to="/news" className="block pl-7 text-gray-500 hover:text-[#00b5e2] text-[14px] leading-tight">News</Link></li>
                    <li><Link to="#" className="block pl-7 text-gray-500 hover:text-[#00b5e2] text-[14px] leading-tight">Facebook</Link></li>
                    <li><Link to="#" className="block pl-7 text-gray-500 hover:text-[#00b5e2] text-[14px] leading-tight">Instagram</Link></li>
                  </ul>
                </li>
                <li><Link to="/contact" className="block pl-5 text-gray-500 hover:text-[#00b5e2] text-[14px] font-medium">Contact Us</Link></li>
              </ul>
            </div>
            {/* SOLUTIONS */}
            <div className="footer-list">
              <h6 className="custom-font-weight text-[16px] mb-5 tracking-wide uppercase">
                Solutions
              </h6>
              <ul className="space-y-4">
                <li>
                  <button onClick={() => toggleDropdown("products")} className="flex items-center gap-1 text-gray-500 hover:text-[#00b5e2] font-medium w-full text-left text-[14px]">
                    {openDropdown === "products" ? <KeyboardArrowDownIcon sx={{ fontSize: 16, color: '#00b5e2' }} /> : <KeyboardArrowRightIcon sx={{ fontSize: 16, color: '#00b5e2' }} />}
                    Products
                  </button>
                  <ul className={`overflow-hidden transition-all duration-300 space-y-0 ${openDropdown === "products" ? "max-h-32" : "max-h-0"}`}>
                    <li><Link to="/Solutions" className="block pl-7 text-gray-500 hover:text-[#00b5e2] text-[14px] leading-tight">Gasoline Products</Link></li>
                    <li><Link to="/Solutions" className="block pl-7 text-gray-500 hover:text-[#00b5e2] text-[14px] leading-tight">Oil Products</Link></li>
                  </ul>
                </li>
                <li><Link to="/Franchise" className="block pl-5 text-gray-500 hover:text-[#00b5e2] text-[14px] font-medium">Franchise</Link></li>
                <li><a href="https://www.facebook.com/quick8servicecenter" target="_blank" rel="noopener noreferrer" className="block pl-5 text-gray-500 hover:text-[#00b5e2] text-[14px] font-medium">Services</a></li>
                <li><a href="https://www.facebook.com/centrumfuel" target="_blank" rel="noopener noreferrer" className="block pl-5 text-gray-500 hover:text-[#00b5e2] text-[14px] font-medium">Careers</a></li>
              </ul>
            </div>
            {/* LOGO & SOCIALS */}
          <div className="footer-detail mb-10 space-y-6">
            <Link to="" className="block">
              <img src={logo} alt="footer-logo" />
            </Link>
            <a
              href="https://www.facebook.com/centrumfuel"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 group cursor-pointer transition-all"
            >
              <div className="w-20 h-20 rounded-full border-2 border-[#E0F2FE] flex items-center justify-center bg-[#F8FBFF] transition-transform duration-300 group-hover:scale-110">
                <FacebookOutlinedIcon sx={{ color: "#00b5e2", fontSize: 28 }} />
              </div>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  cursor: "pointer",
                  whiteSpace: { xs: "nowrap", lg: "normal" },
                  "&:hover": { color: "#00b5e2" },
                }}
              >
                <Box component="span" sx={{ letterSpacing: 2 }}>LIKE US</Box>{" "}
                <Box component="span" sx={{ letterSpacing: 2, mr: 1 }}>ON</Box>
                <Box component="span" sx={{ letterSpacing: 2, display: { xs: "inline", lg: "block" } }}>
                  FACEBOOK
                </Box>
              </Typography>
            </a>
            <a
              href="https://www.instagram.com/centrumfuel.ph/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 group cursor-pointer transition-all"
            >
              <div className="w-20 h-20 rounded-full border-2 border-[#E0F2FE] flex items-center justify-center bg-[#F8FBFF] transition-transform duration-300 group-hover:scale-110">
                <InstagramIcon sx={{ color: "#00b5e2", fontSize: 28 }} />
              </div>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  cursor: "pointer",
                  whiteSpace: { xs: "nowrap", lg: "normal" },
                  "&:hover": { color: "#00b5e2" },
                }}
              >
                <Box component="span" sx={{ letterSpacing: 2 }}>FOLLOW US</Box>{" "}
                <Box component="span" sx={{ letterSpacing: 2, mr: 1 }}>ON</Box>
                <Box component="span" sx={{ letterSpacing: 2, display: { xs: "inline", lg: "block" } }}>
                  INSTAGRAM
                </Box>
              </Typography>
            </a>
          </div>
          </div>
        </div>
      </div>
      <div className="footer-copyright bg-[#ebf4fc] py-10 text-center text-[13px] text-gray-500">
        © Centrum Fuel | Rael Kitz Corporation. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;









